module.exports = __webpack_public_path__ + "media/assets/icons/phone-749088171a1c263c30c2ca33fe512683.svg";